
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 13 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 13 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import $ from 'jquery';
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { Prop, Watch } from "vue-property-decorator";

import { JobFairModel, JobFairPaymentModel } from "@/models/job.model";
import { CoachmarkModel } from "@/models/coachmark.model";

import CoachMark from '@/components/coachmark/Coachmark.vue';
import SmallBadge from "@/components/properties/SmallBadge.vue";
import ModalJobsFair from "@/views/apps/jobsfair/ModalJobsFair.vue";
import ModalConfirmEnd from "@/components/jobfair/ModalConfirmEnd.vue";
import { jobFairPaymentStatus, stepJobFair } from "@/constants/enum.constant";
import ModalJobFairReUploadPayment from "@/components/jobfair/ModalJobFairReUploadPayment.vue";

@Component({
  filters,
  components: {
    ModalJobFairReUploadPayment,
    CoachMark,
    SmallBadge,
    ModalJobsFair,
    ModalConfirmEnd,
  },
})
export default class JobsFairActive extends Vue {
  /* VUEX */

  /* ACTION */
  @Action("actionGetLastJobFair", { namespace: "job" })
  private actionGetLastJobFair: any;
  @Action("actionSelectCoachmark", { namespace: "coachmark" })
  private actionSelectCoachmark: any;
  @Action("actionUpdateCoachmark", { namespace: "coachmark" })
  private actionUpdateCoachmark: any;

  /* STATE */
  @State("locale")
  private locale: any;
  @State("job_fair", { namespace: "job" })
  private job_fair: JobFairModel;
  @State("coachmark_data", { namespace: "coachmark" })
  private coachmark_data: CoachmarkModel;

  @Prop({ default: false })
  private isEdit: boolean;
  @Prop({ default: false })
  private isHistory: boolean;
  // BUG => https://developerx.atlassian.net/browse/CS-5513
  // Fixed on 30 Mar 2022.
  // Fixed by Risman Abdilah.
  @Prop({ default: false })
  private showCoachMarkJobsFair: boolean;

  @Watch("locale")
  private onLocaleChanged() {
    this.getLastJobFair();
  }

  /* INITIALIZATION */
  private activeIndex: number = 0;
  private isShowModalEnd: boolean = false;
  private isShowModalJobsFair: boolean = false;
  private showModalPayment: boolean = false;
  private currentPaymentId: number = 0;
  private currentJobFairId: number = 0;
  private currentPaymentNote: string = "";

  private get steps() {
    return [
      {
        target: "ButtonCreateJobsFair",
        placement: "top",
        title: this.$t('coachmark_title_jobsfair1'),
        content: this.$t('coachmark_desc_jobsfair1'),
      },
    ]
  }

  private get isVerified() {
    return this.job_fair.step === stepJobFair.VERIFIED;
  }

  /* LIFECYCLE */

  private created() {
    if (!this.isEdit) {
      this.getLastJobFair();
    }
    if (this.showCoachMarkJobsFair) {
      window.scrollTo(0, document.body.scrollHeight)
    }
  }

  /* METHODS */
  private getPaymentStatus(payment: JobFairPaymentModel) {
    if (payment.id === 0) {
      return "-";
    } else {
      const lastStatus = payment.statuses[payment.statuses.length - 1].status;
      if (lastStatus === jobFairPaymentStatus.UNPAID) return "Unpaid";
      else if (lastStatus === jobFairPaymentStatus.WAITING_APPROVAL) return "Waiting Approval";
      else if (lastStatus === jobFairPaymentStatus.REJECTED) return "Rejected";
      else if (lastStatus === jobFairPaymentStatus.PAID) return "Paid";
      else return "-";
    }
  }
  private getPaymentStatusColor(payment: JobFairPaymentModel) {
    if (payment.id === 0) {
      return "bg-info";
    } else {
      const lastStatus = payment.statuses[payment.statuses.length - 1].status;
      if (lastStatus === jobFairPaymentStatus.UNPAID) return "bg-danger";
      else if (lastStatus === jobFairPaymentStatus.WAITING_APPROVAL) return "bg-info";
      else if (lastStatus === jobFairPaymentStatus.REJECTED) return "bg-danger";
      else if (lastStatus === jobFairPaymentStatus.PAID) return "bg-success";
      else return "bg-info";
    }
  }
  private canReUpload(payment: JobFairPaymentModel) {
    if (payment.id === 0) {
      return false;
    } else {
      const lastStatus = payment.statuses[payment.statuses.length - 1].status;
      return lastStatus === jobFairPaymentStatus.UNPAID || lastStatus === jobFairPaymentStatus.REJECTED;
    }
  }
  private openReUploadPaymentModal(jobFair: JobFairModel) {
    this.showModalPayment = true;
    this.currentPaymentId = jobFair.payment.id;
    this.currentJobFairId = jobFair.id;
    this.currentPaymentNote = jobFair.payment.statuses[jobFair.payment.statuses.length - 1].note;
  }

  private onNextCoachMark(routeName = "") {
    this.activeIndex++;
    if (routeName) {
      if (routeName === "createJobFair") {
        this.$emit("on-create");
      } else {
        this.$router.push({ name: routeName });
      }
    }
    $('.overlayCoachMark').remove()
    // Old
    // localStorage.setItem('coachmark_jobsfair', 'done');

    // New
    this.coachmark_data.coachmark_news = true;
    this.actionUpdateCoachmark({
      success: () => {
        this.actionSelectCoachmark();
      },
    });
  }

  private goToDetail(id: any) {
    this.$router.push({
      name: "jobsFairDetail",
      params: { job_id: id },
    });
  }

  private getLastJobFair() {
    this.actionGetLastJobFair({
      success: (responseActive: any) => {
        // TODO
      },
      fail: (responseActive: any) => {
        // TODO
      },
    });
  }
}
